import { ClinicType, FeaturedClinic } from 'screens/ExploreClinics/props';
import FeaturedFrame from 'components/FeaturedFrame';
import ClinicCard from './ClinicCard';

interface Props {
  featured: FeaturedClinic[];
  listHoveredClinicId: string | null;
  setListHoveredClinicId: React.Dispatch<React.SetStateAction<string | null>>;
  setListHoveredVenueId: React.Dispatch<React.SetStateAction<string | null>>;
  onClinicDetail: (clinic: ClinicType) => void;
}

/**
 * Surfaces the area's currently boosted clinics in the shared FeaturedFrame above
 * the date-grouped list. Cards reuse the marketplace's own ClinicCard, and each
 * fires a BOOST-sourced impression stamped with its placement.
 */
const FeaturedClinics: React.FC<Props> = ({
  featured,
  listHoveredClinicId,
  setListHoveredClinicId,
  setListHoveredVenueId,
  onClinicDetail,
}) => {
  if (featured.length === 0) return null;

  return (
    <FeaturedFrame>
      <div className="flex flex-col [&>*:last-child:not(:hover)]:border-b-transparent">
        {featured.map(({ clinic, placementId }) => (
          <ClinicCard
            key={clinic.id}
            clinic={clinic}
            listHoveredClinicId={listHoveredClinicId}
            setListHoveredClinicId={setListHoveredClinicId}
            setListHoveredVenueId={setListHoveredVenueId}
            onClinicDetail={onClinicDetail}
            impressionSource="BOOST"
            placementId={placementId}
          />
        ))}
      </div>
    </FeaturedFrame>
  );
};

export default FeaturedClinics;
